import { createDocumentState } from './document-state';
import { createCategoryState } from './category-state';
import { createFilterState } from './filter-state';
import { createPaginationState } from './pagination-state';
import { createUploadState } from './upload-state';

/**
 * Asset bilgileri için tüm state verilerini oluşturur
 * @returns {Object} - Tüm state ve computed değerleri
 */
export const createState = () => {
  // Önce bağımsız state'leri oluştur
  const documentState = createDocumentState();
  const categoryState = createCategoryState();
  const uploadState = createUploadState();
  
  // Bağımlı state'leri oluştur
  const filterState = createFilterState(documentState, categoryState);
  const paginationState = createPaginationState(documentState);

  // Tüm state'leri birleştir
  return {
    ...documentState,
    ...categoryState,
    ...uploadState,
    ...filterState,
    ...paginationState
  };
};